/*
  nazzi-header.js
  Toggle del menu mobile dell'header glass. Vanilla JS, nessuna libreria.
*/
(function () {
  var header = document.querySelector('.nazzi-header');
  if (!header) return;

  var toggle = header.querySelector('.nazzi-header__toggle');
  var panel = header.querySelector('.nazzi-header__panel');
  if (!toggle || !panel) return;

  function setOpen(open) {
    header.classList.toggle('nazzi-header--open', open);
    document.body.classList.toggle('nazzi-menu-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  toggle.addEventListener('click', function () {
    setOpen(!header.classList.contains('nazzi-header--open'));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') setOpen(false);
  });

  document.addEventListener('click', function (event) {
    if (header.classList.contains('nazzi-header--open') && !header.contains(event.target)) {
      setOpen(false);
    }
  });
})();
